import { useCallback } from 'react';
import { changeLoadingState, setErrorMessage } from 'app/settings/slices';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import { selectCurrentBrandId, selectUserConfigIsNightMode } from 'app/userPreferences/selectors';
import { selectResourceDirectoryRule } from 'app/resource/selectors/brand';
import { ErrorMessage } from 'app/settings/types';
import AdminEditor from 'shared/adminEditor/AdminEditor';
import type { AdminEditorProps as AdminEditorComponentProps } from './AdminEditor';

type InjectedProps = 'brandId' | 'directoryRules' | 'isNightMode' | 'setErrorMessage' | 'changeLoadingState';

interface AdminEditorProps extends Omit<AdminEditorComponentProps, InjectedProps> {
  directoryPath?: string
}

export default ({ directoryPath = 'messages', ...rest }: AdminEditorProps) => {
  const brandId = useAppSelector(selectCurrentBrandId);
  const directoryRules = useAppSelector(selectResourceDirectoryRule(directoryPath));
  const isNightMode = useAppSelector(selectUserConfigIsNightMode);

  const dispatch = useAppDispatch();
  const setErrorMessageProp = useCallback((error: ErrorMessage) => dispatch(setErrorMessage(error)), [dispatch]);
  const changeLoadingStateProp = useCallback((loading: boolean) => dispatch(changeLoadingState(loading)), [dispatch]);

  return <AdminEditor directoryPath={directoryPath} {...rest} setErrorMessage={setErrorMessageProp} changeLoadingState={changeLoadingStateProp} brandId={brandId} directoryRules={directoryRules} isNightMode={isNightMode} />;
};
